export const semverGreaterThan = (versionA, versionB) => {
    let result = false;

    if (typeof versionA !== 'object') {
        versionA = versionA.toString().split('.');
    }
    if (typeof versionB !== 'object') {
        versionB = versionB.toString().split('.');
    }

    for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
        if (versionA[i] === undefined) {
            versionA[i] = 0;
        }
        if (versionB[i] === undefined) {
            versionB[i] = 0;
        }

        if (Number(versionA[i]) < Number(versionB[i])) {
            result = true;
            break;
        }
        if (versionA[i] !== versionB[i]) {
            break;
        }
    }
    return result;
};
